export default {
  SET_TASKS: 'SET_TASKS',
  UPDATE_TASK: 'UPDATE_TASK',
  CALCULATE_SCORE: 'CALCULATE_SCORE'
};
